import { FC } from 'react';

import { Loader } from '@hh.ru/magritte-ui';

const Loading: FC = () => <Loader size={24} initial="accent" />;

export default Loading;
